import { Component, OnInit } from '@angular/core';
import * as xlsx from 'xlsx';
import { Company } from 'src/app/models/company';
import { CompanyService } from 'src/app/services/company.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { AccessService } from 'src/app/services/access.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-reprint-shipment-massive',
  templateUrl: './reprint-shipment-massive.component.html',
  styleUrls: ['./reprint-shipment-massive.component.scss'],
  providers: [UtilsService, CompanyService, WarehouseService, AccessService]
})
export class ReprintShipmentMassiveComponent implements OnInit {
  loading;
  company = {} as Company;
  public isReprint: boolean;
  public isDisabled: boolean;
  public begDate: string;
  public endDate: string;
  public userCode: number;
  public storeCode: number;
  public companyCode: number;
  public storeName: string;
  public entries: number = 10;
  public activeRow: any;
  public temp = new Array();
  public shipmentList: any[] = new Array();
  public totalDownload: number = 0;
  public totalErrors: number = 0;

  public settings = {
    columns: {
      shipmentInternNumber: { title: 'Correlativo' },
      shipmentDate: { title: 'Fecha' },
      NombreCliente: { title: 'Cliente' },
      NombrePilot: { title: 'Piloto' },
      shipmentAuthorization: { title: 'CDC' },
      Estado: { title: 'Estado DNIT' }
    }
  };

  constructor(
    private _utilsService: UtilsService,
    private _companyService: CompanyService,
    private _warehouseService: WarehouseService,
    private _accessService: AccessService
  ) { }

  async ngOnInit() {
    const _data = JSON.parse(localStorage.getItem('data'));
    this.storeName = _data.storeName ? _data.storeName.toString() : null;
    this.userCode = _data.userCode ? parseInt(_data.userCode.toString()) : 0;
    this.storeCode = _data.storeCode ? parseInt(_data.storeCode.toString()) : 0;
    this.companyCode = _data.companyCode ? parseInt(_data.companyCode.toString()) : 0;

    this.begDate = this._utilsService.dateTime('yyy-MM-dd');
    this.endDate = this._utilsService.dateTime('yyy-MM-dd');
    this.isReprint = false;

    await this.getCompany(this.companyCode);
  }

  entriesChange($event) {
    this.entries = $event.target.value;
  }

  filterTable($event) {
    const val = $event.target.value.toLowerCase();
    this.temp = this.shipmentList.filter(d => {
      for (const key in d) {
        if (d[key] !== null && d[key].toString().toLowerCase().indexOf(val) !== -1) {
          return true;
        }
      }
      return false;
    });
  }

  onActivate(event) {
    this.activeRow = event.row;
  }

  getCompany(company) {
    return this._companyService.getOne(company).then(
      response => {
        if (response.result) {
          this.company = response.records[0];
        } else {
          console.log(response.message);
        }
      },
      error => console.log(error)
    );
  }

  getAll() {
    this.totalDownload = 0;
    this.totalErrors = 0;
    this.isDisabled = true;

    if (!this.begDate || !this.endDate) {
      this.isDisabled = false;
      this._utilsService.showNotification(2, 'Ingresar Datos');
      return;
    }

    this.loading = true;
    const json = { store: this.storeCode, begDate: this.begDate, endDate: this.endDate };

    this._warehouseService.getTransferByStore(json).then(
      (response) => {
        if (response.result == true) {
          this.shipmentList = response.records.map(s => ({
            ...s,
            downloadStatus: ''
          }));
          this.shipmentList.sort((a, b) => a.shipmentInternNumber - b.shipmentInternNumber);
          this.temp = this.shipmentList;
          this.isReprint = true;
          this.isDisabled = false;
          this._utilsService.showNotification(1, response.message);
        } else {
          this.isDisabled = false;
          this._utilsService.showNotification(3, response.errorMessage);
        }
      },
      error => {
        this.isDisabled = false;
        this._utilsService.showNotification(2, error);
        console.log(error);
      }
    ).finally(() => { this.loading = false; });
  }

  async downloadMassive() {
    this.totalDownload = 0;
    this.totalErrors = 0;
    this.isDisabled = true;

    for (const row of this.temp) {
      this.loading = true;
      try {
        const response: any = await this._warehouseService.getDeliveryMegaLocalPY(this.buildBody(row));
        await this.downloadUrlS3(response.records.url, 'notaremision-' + row.shipmentAuthorization, 'pdf');
        this.totalDownload++;
        row.downloadStatus = 'Exitoso';
        this._utilsService.showNotification(1, 'Remisión descargada: ' + row.shipmentInternNumber);
      } catch (error) {
        this.totalErrors++;
        row.downloadStatus = typeof error === 'string' ? error : (error.message || JSON.stringify(error));
        this._utilsService.showNotification(2, 'Error en correlativo ' + row.shipmentInternNumber + ': ' + error);
        console.log('Error row:', row, error);
      } finally {
        this.loading = false;
        this.temp = [...this.temp];
      }
      await new Promise(resolve => setTimeout(resolve, 2000));
    }

    this.isDisabled = false;
    this._utilsService.showNotification(1, `Proceso finalizado. Descargadas: ${this.totalDownload}, Errores: ${this.totalErrors}`);
  }

  async searchShipment($event, row) {
    $event.preventDefault();
    this.loading = true;
    this.isDisabled = true;

    try {
      const response: any = await this._warehouseService.getDeliveryMegaLocalPY(this.buildBody(row));
      await this.downloadUrlS3(response.records.url, 'notaremision-' + row.shipmentAuthorization, 'pdf');
      row.downloadStatus = 'Exitoso';
      this._utilsService.showNotification(1, 'Remisión Generada Correctamente');
    } catch (error) {
      row.downloadStatus = typeof error === 'string' ? error : (error.message || JSON.stringify(error));
      this._utilsService.showNotification(2, error);
      console.log(error);
    } finally {
      this.temp = [...this.temp];
      this.loading = false;
      this.isDisabled = false;
    }
  }

  private buildBody(row: any) {
    return {
      shipment: {
        shipmentCode: row.cod_shipment,
        cdc: row.shipmentAuthorization
      },
      transmitter: {
        transmitterPrefix: this.company.companyPrefix,
        transmitterToken: this.company.companyToken
      }
    };
  }

  async downloadUrlS3(urlFirmada: string, nombreFile: string, format: string) {
    const response = await fetch(urlFirmada);
    const blob = await response.blob();
    const urlBlob = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = urlBlob;
    link.download = nombreFile + '.' + format;
    link.click();
    window.URL.revokeObjectURL(urlBlob);
  }

  async downloadToExcel() {
    const exportFile = new Array<any>();
    this.temp.forEach(element => {
      let json = {};
      Object.keys(this.settings.columns).forEach(item => {
        json[this.settings.columns[item].title] = element[item];
      });
      exportFile.push(json);
    });
    const ws: xlsx.WorkSheet = xlsx.utils.json_to_sheet(exportFile);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, 'Reporte');
    xlsx.writeFile(wb, 'reporte-descarga-masiva-remisiones.xlsx');
  }
}
